import { all, takeEvery, put, fork, select } from 'redux-saga/effects';
import actions from './actions';
import { PUT, post, get } from '@iso/lib/helpers/resApiRequestor';
import { filterDuplicateData } from '@iso/lib/helpers/utility';

export function* updateVat() {
  yield takeEvery('UPDATE_VAT_AGGREE', function* ({ payload }) {
    try {
      yield put({
        type: actions.UPDATING_VAT_AGGREE,
        payload: true
      });
      const apiResult = yield updatingVat(payload);
      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.GOT_USER_SETTINGS,
          payload: result.data
        });
        yield put({
          type: actions.UPDATING_VAT_AGGREE,
          payload: false
        });
      } else {
        yield put({
          type: actions.ERROR_USER_SETTINGS,
          payload: true
        });
      }
    } catch (error) {
      yield put({
        type: actions.ERROR_USER_SETTINGS,
        payload: true
      });
    }
  });
}
export function* fetchPaymentCounts() {
  yield takeEvery('FETCH_PAYMENT_COUNT', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_PAYMENT_COUNT
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchPaymentCountsInfo(payload, roleHeaderAuth);
      const result = apiResult.data;
      if (result.success === true) {
        yield put({
          type: actions.FETCHED_PAYMENT_COUNT,
          payload: result.data
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCHING_PAYMENT_COUNT_FAILED,
        payload: null
      });
    }
  });
}
export function* fetchSuccessRate() {
  yield takeEvery('FETCH_SUCCESS_RATE', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_SUCCESS_RATE,
        filter: payload
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchSuccessRateAPI(payload, roleHeaderAuth);
      const result = apiResult.data;

      if (result.success === true) {
        yield put({
          type: actions.FETCH_SUCCESS_RATE_SUCCESS,
          payload: result.data,
          pagination: result.pagination
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_SUCCESS_RATE_FAILED,
        payload: null
      });
    }
  });
}

export function* fetchAccountNotification() {
  yield takeEvery('FETCH_ACCOUNT_NOTIFICATION', function* ({ payload }) {
    try {
      const pagination = payload.pagination;
      const loadmore = pagination.loadMore;
      if (loadmore) {
        yield put({
          type: actions.LOADING_MORE_ACCOUNT_NOTIFICATION
        });
      } else {
        yield put({
          type: actions.FETCHING_ACCOUNT_NOTIFICATION,
          loading: true
        });
      }
      const roleHeaderAuth = yield getDefaultRoleHeader();
      const apiResult = yield fetchNotificationDataAPI(payload, roleHeaderAuth);
      const currentList =
        pagination.currentNotification && loadmore ? pagination.currentNotification : [];

      const result = apiResult.data;

      const parseData =
        currentList && currentList.length > 0
          ? currentList.concat(result.data.notifications)
          : result.data.notifications;

      const finalData = parseData ? filterDuplicateData(parseData) : [];
      const checkUnreadNotif = result.data.total_unclicked_notifications;

      if (result.success) {
        yield put({
          type: actions.FETCH_ACCOUNT_NOTIFICATION_SUCCESS,
          loading: false,
          result: finalData,
          pagination: result ? result.pagination : null,
          unreadCount: checkUnreadNotif ? checkUnreadNotif : 0
        });
      } else {
        yield put({
          type: actions.FETCH_ACCOUNT_NOTIFICATION_FAILED,
          loading: false,
          payload: currentList
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_ACCOUNT_NOTIFICATION_FAILED,
        loading: false,
        payload: []
      });
    }
  });
}
export function* fetchSystemLogs() {
  yield takeEvery('FETCH_ACCOUNT_SYSTEM_LOGS', function* ({ payload }) {
    try {
      const pagination = payload.pagination;
      const loadmore = pagination.loadMore;
      if (loadmore) {
        yield put({
          type: actions.LOADING_MORE_ACCOUNT_SYSTEM_LOGS
        });
      } else {
        yield put({
          type: actions.FETCHING_ACCOUNT_SYSTEM_LOGS,
          loading: true
        });
      }
      const roleHeaderAuth = yield getDefaultRoleHeader();
      const apiResult = yield fetchSystemLogsAPI(payload, roleHeaderAuth);
      const currentList =
        pagination.currentNotification && loadmore ? pagination.currentNotification : [];

      const result = apiResult.data;

      const logs = result.data.logs;
      const newLogs = logs.map(log => {
        const value = typeof log.value !== 'string' ? log.value : JSON.parse(log.value);
        return { ...log, value };
      });

      const parseData =
        currentList && currentList.length > 0 ? currentList.concat(newLogs) : newLogs;

      const finalData = parseData ? filterDuplicateData(parseData) : [];
      const checkUnreadNotif = result.data.total_unread_notifications;

      if (result.success) {
        yield put({
          type: actions.FETCH_ACCOUNT_SYSTEM_LOGS_SUCCESS,
          loading: false,
          result: finalData,
          pagination: result ? result.pagination : null,
          unreadCount: checkUnreadNotif ? checkUnreadNotif : 0
        });
      } else {
        yield put({
          type: actions.FETCH_ACCOUNT_SYSTEM_LOGS_FAILED,
          loading: false,
          payload: currentList
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_ACCOUNT_SYSTEM_LOGS_FAILED,
        loading: false,
        payload: []
      });
    }
  });
}

export function* isReadNotification() {
  yield takeEvery('READ_ACCOUNT_NOTIFICATION', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.READING_ACCOUNT_NOTIFICATION,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield readAccountNotificationDataAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        const state = yield select();
        const accountNotificationData = state.Dashboard.accountNotificationData;
        const currentUnreadCount = state.Dashboard.unreadCount;
        let currentLogList = accountNotificationData;

        if (currentLogList && currentLogList.length > 0) {
          //Find index of specific object using findIndex method.
          let objIndex = currentLogList.findIndex(obj => obj.id === id);
          currentLogList[objIndex].is_clicked = true;
        }

        yield put({
          type: actions.READ_ACCOUNT_NOTIFICATION_SUCCESS,
          loading: false,
          payload: currentLogList,
          unreadCount: currentUnreadCount ? currentUnreadCount - 1 : 0
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.READ_ACCOUNT_NOTIFICATION_FAILED,
            loading: false
          });
        } else {
          yield put({
            type: actions.READ_ACCOUNT_NOTIFICATION_FAILED,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.READ_ACCOUNT_NOTIFICATION_FAILED,
        loading: false
      });
    }
  });
}

export function* isReadLogs() {
  yield takeEvery('READ_ACCOUNT_SYSTEM_LOGS', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.READING_ACCOUNT_SYSTEM_LOGS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield readAccountSystemLogsDataAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        const state = yield select();
        const accountSystemLogsData = state.Dashboard.accountSystemLogsData;
        const currentUnreadCount = state.Dashboard.systemLogsUnreadCount;
        let currentLogList = accountSystemLogsData;

        if (currentLogList && currentLogList.length > 0) {
          //Find index of specific object using findIndex method.
          let objIndex = currentLogList.findIndex(obj => obj.id === id);
          currentLogList[objIndex].is_read = true;
        }

        yield put({
          type: actions.READ_ACCOUNT_SYSTEM_LOGS_SUCCESS,
          loading: false,
          payload: currentLogList,
          unreadCount: currentUnreadCount ? currentUnreadCount - 1 : 0
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.READ_ACCOUNT_SYSTEM_LOGS_FAILED,
            loading: false
          });
        } else {
          yield put({
            type: actions.READ_ACCOUNT_SYSTEM_LOGS_FAILED,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.READ_ACCOUNT_SYSTEM_LOGS_FAILED,
        loading: false
      });
    }
  });
}

export function* fetchApprovalRequests() {
  yield takeEvery('FETCH_APPROVAL_REQUESTS', function* ({ payload }) {
    try {
      const pagination = payload.pagination;
      const loadmore = pagination.loadMore;
      if (loadmore) {
        yield put({
          type: actions.LOADING_MORE_APPROVAL_REQUESTS
        });
      } else {
        yield put({
          type: actions.FETCHING_APPROVAL_REQUESTS,
          loading: true
        });
      }
      const roleHeaderAuth = yield getDefaultRoleHeader();
      const apiResult = yield fetchApprovalRequestsAPI(payload, roleHeaderAuth);
      const currentList =
        pagination.currentNotification && loadmore ? pagination.currentNotification : [];

      const result = apiResult.data;

      if (result.success) {
        const parseData =
          currentList && currentList.length > 0
            ? currentList.concat(result.data.validation)
            : result.data.validation;

        const finalData = parseData ? filterDuplicateData(parseData) : [];

        yield put({
          type: actions.FETCH_APPROVAL_REQUESTS_SUCCESS,
          loading: false,
          result: finalData,
          pagination: result ? result.pagination : null,
          filter: payload
        });
      } else {
        yield put({
          type: actions.FETCH_APPROVAL_REQUESTS_FAILED,
          loading: false,
          payload: currentList
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_APPROVAL_REQUESTS_FAILED,
        loading: false,
        payload: []
      });
    }
  });
}

export function* updateApprovalRequestData() {
  yield takeEvery('UPDATE_APPROVAL_REQUEST_STATUS', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.UPDATING_APPROVAL_REQUEST_STATUS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield updateApprovalRequestDataAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.UPDATE_APPROVAL_REQUEST_STATUS_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.RESET_APPROVAL_REQUESTS
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.UPDATE_APPROVAL_REQUEST_STATUS_FAILED,
            loading: false,
            message: `Endpoint ${result.title}`
          });
        } else {
          yield put({
            type: actions.UPDATE_APPROVAL_REQUEST_STATUS_FAILED,
            loading: false,
            message: 'Failed to process request'
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.UPDATE_APPROVAL_REQUEST_STATUS_FAILED,
        loading: false,
        message: 'Failed to process request'
      });
    }
  });
}

export function* markAsReadAllLogAction() {
  yield takeEvery('MARK_AS_READ_ALL_LOG_ACTION', function* () {
    try {
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield markAsReadAllLogActionAPI(roleHeaderAuth);
      const result = apiResult.data;
      if (result.success === true) {
        yield put({
          type: actions.FETCH_ACCOUNT_SYSTEM_LOGS,
          payload: {
            pagination: { page: 0, limit: 10 }
          }
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_ACCOUNT_SYSTEM_LOGS,
        payload: {
          pagination: { page: 0, limit: 10 }
        }
      });
    }
  });
}

export function* markAsReadAllNotification() {
  yield takeEvery('MARK_AS_READ_ALL_NOTIFICATION', function* () {
    try {
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield markAsReadAllNotificationAPI(roleHeaderAuth);
      const result = apiResult.data;
      if (result.success === true) {
        yield put({
          type: actions.FETCH_ACCOUNT_NOTIFICATION,
          payload: {
            pagination: { page: 0, limit: 10 }
          },
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_ACCOUNT_NOTIFICATION,
        payload: {
            pagination: { page: 0, limit: 10 }
          },
      });
    }
  });
}

function* getRoleHeader() {
  const state = yield select();
  const identity = state.Auth.identity;
  const currentPage = state.App.currentPage;
  const currentAction = state.App.currentAction;
  if (currentAction) {
    return `${identity.role_id}:${currentPage.id}:${currentAction.id}`;
  } else {
    return `${identity.role_id}:${currentPage.id}`;
  }
}
function* getDefaultRoleHeader() {
  const state = yield select();
  const identity = state.Auth.identity;
  const defaultModule = state.Auth.modules;
  if (defaultModule && defaultModule.length > 0) {
    return `${identity.role_id}:${defaultModule[0].pages[0].id}`;
  } else {
    return `${identity.role_id}`;
  }
}
function fetchPaymentCountsInfo(data, roleAuth) {
  return post(`get/monitoring-data/dashboard-data`, data, null, null, roleAuth);
}
function fetchSuccessRateAPI(data, roleAuth) {
  return post(`get/monitoring-data/success-rate`, data, null, null, roleAuth);
}

function updatingVat(username) {
  return PUT(`dashboard/update_user_settings/${username}`);
}
function fetchNotificationDataAPI(data, roleAuth) {
  return get(
    `get/user/system-notification`,
    data,
    null, //pagination ? pagination : { page: 0, limit: 10 }
    null,
    null,
    roleAuth
  );
}
function fetchSystemLogsAPI(data, roleAuth) {
  return get(
    `get/user/system-logs`,
    data,
    null,
    null,
    null,
    roleAuth
  );
}
function fetchApprovalRequestsAPI(data, roleAuth) {
  return post(
    `get/user-assignee/validation-requirement`,
    data,
    null,//pagination ? pagination : { page: 0, limit: 10 },
    null,
    roleAuth
  );
}
function readAccountNotificationDataAPI(data, id, roleAuth) {
  return PUT(`mark-as-clicked/system-notification/${id}`, data, null, roleAuth);
}
function markAsReadAllNotificationAPI(roleAuth) {
  return PUT(`mark-as-clicked/all/system-notification`, null, null, roleAuth);
}
function readAccountSystemLogsDataAPI(data, id, roleAuth) {
  return PUT(`mark-as-read/system-logs/${id}`, data, null, roleAuth);
}
function markAsReadAllLogActionAPI(roleAuth) {
  return PUT(`mark-as-read/all/system-logs`, null, null, roleAuth);
}
function updateApprovalRequestDataAPI(data, id, roleAuth) {
  return PUT(`status/updated/validation-requirement/${id}`, data, null, roleAuth);
}

export default function* rootSaga() {
  yield all([
    fork(fetchPaymentCounts),
    updateVat(),
    fork(fetchAccountNotification),
    fork(isReadNotification),
    fork(fetchSystemLogs),
    fork(isReadLogs),
    fork(fetchApprovalRequests),
    fork(updateApprovalRequestData),
    fork(markAsReadAllLogAction),
    fork(markAsReadAllNotification),
    fork(fetchSuccessRate)
  ]);
}
